import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/delete-bottom.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-68c3c33e")

_pushScopeId("data-v-68c3c33e")
const _hoisted_1 = { class: "shell padding30px" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  class: "display-flex",
  style: {"align-items":"baseline"}
}
const _hoisted_4 = {
  style: {"color":"gray"},
  class: "margin-left10px"
}
const _hoisted_5 = { style: {"color":"gray"} }
const _hoisted_6 = {
  style: {"color":"gray"},
  class: "margin-bottom10px"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_property_bread_crumb = _resolveComponent("property-bread-crumb")
  const _component_item_title = _resolveComponent("item-title")
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_choose_img = _resolveComponent("choose-img")
  const _component_el_form = _resolveComponent("el-form")
  const _component_cus_button = _resolveComponent("cus-button")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_property_bread_crumb, { headers: _ctx.breadCrumbHeaders }, null, 8, ["headers"]),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        "label-position": _ctx.$formLabelPosition,
        model: _ctx.formData,
        rules: _ctx.rules,
        ref: "formRef"
      }, {
        default: _withId(() => [
          _createVNode(_component_item_title, {
            name: _ctx.$wordList.OrderDevice
          }, null, 8, ["name"]),
          _createVNode(_component_el_form_item, { prop: "DeviceUUID" }, {
            default: _withId(() => [
              (_ctx.type==='add')
                ? (_openBlock(), _createBlock(_component_cus_select, {
                    key: 0,
                    modelValue: _ctx.formData.DeviceUUID,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.DeviceUUID = $event))
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deviceList.rows, (item) => {
                        return (_openBlock(), _createBlock(_component_cus_option, {
                          key: item.UUID,
                          label: item.Location,
                          value: item.UUID
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : (_openBlock(), _createBlock("label", _hoisted_2, _toDisplayString(_ctx.editLocation), 1))
            ]),
            _: 1
          }),
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_item_title, {
              name: _ctx.$wordList.Picture
            }, null, 8, ["name"]),
            _createVNode("label", _hoisted_4, "(" + _toDisplayString(_ctx.$wordList.ScreensaverUpLength) + ")", 1)
          ]),
          _createVNode(_component_el_form_item, null, {
            default: _withId(() => [
              _createVNode("div", null, [
                _createVNode("p", null, _toDisplayString(_ctx.$wordList.OfficialBoutique), 1),
                _createVNode(_component_el_checkbox_group, {
                  modelValue: _ctx.saveOfficialImg,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveOfficialImg = $event)),
                  class: "display-flex all-images"
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.saveImgList.system, (item) => {
                      return (_openBlock(), _createBlock("div", {
                        key: item.UUID,
                        class: "img-item"
                      }, [
                        _createVNode("img", {
                          src: item.Path,
                          class: "official",
                          onClick: ($event: any) => (_ctx.saveImg(_ctx.saveOfficialImg, item.UUID)),
                          style: {cursor: (_ctx.upperLimit&&!_ctx.saveOfficialImg.includes(item.UUID))?'not-allowed':'pointer'}
                        }, null, 12, ["src", "onClick"]),
                        _createVNode(_component_el_checkbox, {
                          label: item.UUID,
                          disabled: (_ctx.upperLimit&&!_ctx.saveOfficialImg.includes(item.UUID))
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "disabled"])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createVNode("div", null, [
                _createVNode("p", null, _toDisplayString(_ctx.$wordList.Customized), 1),
                _createVNode("p", _hoisted_5, _toDisplayString(_ctx.$wordList.CustomizedImgLimit), 1),
                _createVNode(_component_el_checkbox_group, {
                  modelValue: _ctx.saveCustomizedImg,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveCustomizedImg = $event)),
                  class: "display-flex all-images"
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.saveImgList.project, (item, index) => {
                      return (_openBlock(), _createBlock("div", {
                        key: item.UUID,
                        class: "img-item"
                      }, [
                        _createVNode("div", {
                          class: "customized",
                          onClick: ($event: any) => (_ctx.saveImg(_ctx.saveCustomizedImg, item.UUID)),
                          style: {cursor: (_ctx.upperLimit&&!_ctx.saveCustomizedImg.includes(item.UUID))?'not-allowed':'pointer'}
                        }, [
                          _createVNode("img", {
                            src: item.Path,
                            class: "last-save"
                          }, null, 8, ["src"]),
                          _createVNode("img", {
                            onClick: ($event: any) => (_ctx.removeCustomizedImg($event, index, item.UUID)),
                            class: "del-btn",
                            src: _imports_0
                          }, null, 8, ["onClick"])
                        ], 12, ["onClick"]),
                        _createVNode(_component_el_checkbox, {
                          label: item.UUID,
                          disabled: (_ctx.upperLimit&&!_ctx.saveCustomizedImg.includes(item.UUID))
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "disabled"])
                      ]))
                    }), 128)),
                    (_ctx.saveImgList.project.length < 5)
                      ? (_openBlock(), _createBlock(_component_choose_img, {
                          key: 0,
                          ref: "addCusImg",
                          onChange: _ctx.selectCustomImg,
                          accept: ".jpg"
                        }, null, 8, ["onChange"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_item_title, {
            name: _ctx.$wordList.ScreenSaverMode
          }, null, 8, ["name"]),
          _createVNode(_component_el_form_item, null, {
            default: _withId(() => [
              _createVNode(_component_cus_select, {
                modelValue: _ctx.formData.Mode,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.Mode = $event))
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modeOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_cus_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["label-position", "model", "rules"]),
      _createVNode("p", _hoisted_6, _toDisplayString(_ctx.$wordList.ScreensaverSubmitTips), 1),
      _createVNode(_component_cus_button, {
        type: "blue",
        onClick: _ctx.submit
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootSubmit), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
})